import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTranslaterStore } from './translater'

export const useTokenStore = defineStore('token', () => {
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const translaterStore = useTranslaterStore()

    const REQUEST_DELAY = 5000
    const access = ref(null)
    const refresh = ref(null)
    const accessExpired = ref(null)
    const refreshExpired = ref(null)
    const refreshPromise = ref(null)

    const getTranslate = computed(() => translaterStore.getTranslate)

    async function addToken(payload) {
        if (payload) {
            access.value = payload.tokens.access
            refresh.value = payload.tokens.refresh
            accessExpired.value = payload.tokens.accessExpires.at * 1000
            refreshExpired.value = payload.tokens.refreshExpires.at * 1000

            localStorage.setItem('ASW_TOKEN_ACCESS', payload.tokens.access)
            localStorage.setItem('ASW_TOKEN_REFRESH', payload.tokens.refresh)
            localStorage.setItem('ASW_AE', payload.tokens.accessExpires.at * 1000)
            localStorage.setItem('ASW_RE', payload.tokens.refreshExpires.at * 1000)
            localStorage.setItem('ASW_UUID', payload.uuid)
        } else if (
            localStorage.getItem('ASW_TOKEN_ACCESS') &&
            localStorage.getItem('ASW_TOKEN_REFRESH') &&
            localStorage.getItem('ASW_AE') &&
            localStorage.getItem('ASW_RE') &&
            localStorage.getItem('ASW_UUID')
        ) {
            access.value = localStorage.getItem('ASW_TOKEN_ACCESS')
            refresh.value = localStorage.getItem('ASW_TOKEN_REFRESH')
            accessExpired.value = localStorage.getItem('ASW_AE')
            refreshExpired.value = localStorage.getItem('ASW_RE')
        } else {
            access.value = null
        }

        return access.value
    }

    async function refreshToken() {
        while (true) {
            try {
                const request = await requestsStore.fetchRequestWoToken({
                    address: `${configStore.httpServer}/auth/refresh_access_token`,
                    method: 'POST',
                    data: { refresh: refresh.value }
                })

                console.log('refreshToken: ETokenError')

                if (!request.access || !request.accessExpires) {
                    // Время жизни refresh token истекло
                    if (request.error == 'ETokenExpired' || request.error == 'ETokenError') {
                        return requestsStore.logout()
                    }

                    throw new Error(getTranslate.value.TOKEN_BAD_REQUEST)
                }

                if (!request.error) {
                    access.value = request.access
                    accessExpired.value = request.accessExpires.at * 1000

                    localStorage.setItem('ASW_TOKEN_ACCESS', request.access)
                    localStorage.setItem('ASW_AE', request.accessExpires.at * 1000)

                    return request
                }
            } catch (error) {
                console.error(
                    `${getTranslate.value.ERROR}:`,
                    error.message,
                    `${getTranslate.value.TOKEN_REPEAT_REQUEST} ${REQUEST_DELAY / 1000} ${getTranslate.value.UNIT_SECOND_LONG}`
                )
                await new Promise(resolve => setTimeout(resolve, REQUEST_DELAY))
            }
        }
    }

    return {
        access,
        refresh,
        accessExpired,
        refreshExpired,
        refreshPromise,
        addToken,
        refreshToken
    }
})
